/** Current privacy policy version — must match what is displayed to users */
export const PRIVACY_POLICY_VERSION = "1.0";
